import { useCallback } from "react";
import api, { openApi } from "../../services/api";

const useSettings = () => {
  // ✅ CORREÇÃO FELIPE: Memoizar funções para evitar loop infinito em useEffects que as usam como dependência
  const getAll = useCallback(async (params) => {
    const { data } = await api.request({
      url: "/settings",
      method: "GET",
      params,
    });
    return data;
  }, []);

  const update = useCallback(async (data) => {
    const { data: responseData } = await api.request({
      url: `/settings/${data.key}`,
      method: "PUT",
      data,
    });
    console.log(responseData);
    return responseData;
  }, []);

  const get = useCallback(async (param) => {
    const { data } = await api.request({
      url: `/setting/${param}`,
      method: "GET",
    });
    return data;
  }, []);

  const getPublicSetting = useCallback(async (key, companyId = null) => {
    const params = {
      ...(companyId ? { companyId } : {}),
    };
    const token = process.env.REACT_APP_ENV_TOKEN || process.env.ENV_TOKEN;
    if (token) params.token = token;
    const { data } = await openApi.request({
      url: `/public-settings/${key}`,
      method: "GET",
      params,
    });
    return data;
  }, []);

  // Busca setting global (da company master - ID 1) usando autenticação
  const getGlobalSetting = useCallback(async (key) => {
    const { data } = await api.request({
      url: `/setting-global/${key}`,
      method: "GET",
    });
    return data;
  }, []);

  return {
    getAll,
    update,
    get,
    getPublicSetting,
    getGlobalSetting,
  };
};

export default useSettings;
